module.exports = __webpack_public_path__ + "static/media/D_7.d72cd7b4.png";